import React, {useMemo} from 'react';
import MediaPickerModal from '../Component/MediaPickerModal';
import {useLocale} from '../Localization/LocaleContext';

const getParentOrigin = () => {
  if (typeof window === 'undefined') return '*';

  const configuredOrigin = new URLSearchParams(window.location.search).get(
    'parentOrigin',
  );
  if (configuredOrigin) {
    try {
      return new URL(configuredOrigin).origin;
    } catch (error) {
      return '*';
    }
  }

  try {
    return document.referrer ? new URL(document.referrer).origin : '*';
  } catch (error) {
    return '*';
  }
};

const MediaPickerPage = () => {
  const {translate: t} = useLocale();
  const parentOrigin = useMemo(getParentOrigin, []);

  const postMessage = (type, media) => {
    if (typeof window === 'undefined' || window.parent === window) return;
    window.parent.postMessage({type, media}, parentOrigin);
  };

  return (
    <MediaPickerModal
      isOpen
      title={t('media_picker.title')}
      multiple={new URLSearchParams(window.location.search).get('multiple') === 'true'}
      allowedTypes={new URLSearchParams(window.location.search).get('types')?.split(',').filter(Boolean)}
      onSelect={media => postMessage('media-selected', media)}
      onClose={() => postMessage('media-picker-close')}
    />
  );
};

export default MediaPickerPage;
